/**Информация о задаче weeek */
export class WeeekTaskModel {
  /**ID задачи */
  WeeekTaskId!: number;
  /**ID рабочей области */
	WeeekWorkspaceId?: number;
  
  constructor(obj?: Partial<WeeekTaskModel>) {
    Object.assign(this, obj);
  }
}